import React, { useContext } from 'react'
import styled from 'styled-components'

import ClockIcon from '@Assets/SVG/Clock'
import LetterIcon from '@Assets/SVG/Letter'
import PhoneIcon from '@Assets/SVG/Phone'
import { FooterElement, SectionTitle } from '@Components/Footer/styled'
import { SVGIcon } from '@Components/Icons'
import { Link } from '@Components/Link'
import { NavigationEvent } from '@Events/Navigation'
import { MetadataContext } from '@Globals/Metadata'
import { up } from '@Globals/Style/breakpoints'
import { useTranslation } from '@Globals/Translations'

const StyledContact = styled(FooterElement)`
  order: 2;
  ${up('tablet')} {
    order: 3;
  }
  ${up('desktop')} {
    order: 2;
  }
`

export const Contact = () => {
  const { t } = useTranslation()
  const { store, storeURL } = useContext(MetadataContext)
  const phone = store?.config?.phone

  const contactURL = storeURL('info/contact')

  return (
    <StyledContact className="top">
      <SectionTitle>{t('footer:FOOTER_CONTACT_TITLE')}</SectionTitle>
      <div className="container">
        <div className="row">
          <SVGIcon icon={LetterIcon} />
          <Link
            className="link"
            event={new NavigationEvent({
              attributes: {
                dest_page_type: 'contact',
                dest_page_type_id: '',
                source_id: 'footer_contact_us',
              },
              eventName: 'nav_link_click',
            })}
            href={contactURL}
          >
            {t('footer:FOOTER_CONTACT_EMAIL_US')}
          </Link>
        </div>
        <a className="row" href={`tel:${phone}`}>
          <SVGIcon icon={PhoneIcon} />
          <span className="link">{phone}</span>
        </a>
        <div className="row">
          <SVGIcon icon={ClockIcon} />
          <p className="itemText">{t('footer:FOOTER_CONTACT_PHONES_ARE_OPEN_BETWEEN')}</p>
        </div>
      </div>
    </StyledContact>
  )
}
